import React, {Component} from 'react';
import { List, Button, Toast, Carousel } from 'antd-mobile';
import Blank from '../components/Blank';
import LoadingPlaceholder from '../components/LoadingPlaceholder';
import TipPlaceholder from '../components/TipPlaceholder';
import ProfileView from '../components/ProfileView';
import DataFetcher from '../utils/DataFetcher';
import CommonUtils from '../utils/CommonUtils';
import BrandUtils from '../utils/BrandUtils';
import Constants from '../utils/Constants';
import { createForm } from 'rc-form';
import imgBanner01 from '../medias/banner01.jpg';
import imgBanner02 from '../medias/banner02.jpg';
import '../styles/UserCouponActivity.css';

const history = require("history").createHashHistory()

class UserCouponActivity extends Component {
    constructor(props) {
        super(props);

        this.state = {
            status: 'loading',
            couponActivity: {},
            enableGrab: false,
            brandInfo: null,
            deviceTypes: []
        }
    }

    componentDidMount() {
        this.code = CommonUtils.resolveSearchParam(this.props.location, 'code')
        this.activityId = CommonUtils.resolveSearchParam(this.props.location, 'state')
        if(CommonUtils.isEmpty(this.activityId)) {
            Toast.fail('无法识别活动码')
            this.setState({
                status: 'noauth'
            })
            return
        }

        if(this.code) {
            this.login()
        } else {
            this.setState({
                status: 'success'
            })
            this.loadInitData()
        }
    }

    login = () => {
        DataFetcher.login({
            code: this.code
        }, {
            success: (resp) => {
                this.setState({
                    status: 'success'
                })
                this.loadInitData()
            },
            logicError: () => {
                this.setState({
                    status: 'success'
                })
                this.loadInitData()
            },
            sysError: () => {
                this.setState({
                    status: 'noauth'
                })
            }
        });
    }

    loadInitData = () => {
        this.loadDeviceTypes()
        this.loadBranInfo()
        this.loadCouponActivity()
    }

    loadDeviceTypes = () => {
        DataFetcher.deviceTypes({}, {
            success: (resp) => {
                this.setState({
                    deviceTypes: resp.data
                })
            }
        })
    }

    loadBranInfo = () => {
        DataFetcher.brandInfo({
        }, {
            success: (resp) => {
                this.setState({
                    brandInfo: resp.data
                }, () => {
                    BrandUtils.refreshPageBrand(this.state.brandInfo)
                })
            }
        })
    }

    loadCouponActivity = () => {
        DataFetcher.userCouponActivity({
            activityId: this.activityId
        }, {
            success: (resp) => {
                let enableGrab = this.canGrabCoupon(resp.data)
                this.setState({
                    enableGrab,
                    couponActivity: resp.data
                })
            },
            completed: () => {
                this.setState({
                    status: 'success'
                })
            }
        })
    }

    canGrabCoupon = (couponActivity) => {
        if(!couponActivity || !couponActivity.id) {
            return false
        }

        if(!couponActivity.canGrab) {
            return false
        }

        if(couponActivity.progress !== 'ONGOING') {
            return false
        }

        return true
    }

    handleGrabClick = () => {
        if(!this.state.enableGrab) {
            return
        }

        this.setState({
            enableGrab: false
        })
        DataFetcher.grabCouponByActivity({
            activityId: this.activityId
        }, {
            success: (resp) => {
                Toast.info('抢券成功！')
            },
            completed: () => {
                this.loadCouponActivity()
            }
        })
    }

    handleUseCouponClick = () => {
        history.push('/user/coupon_usage')
    }

    generateBannerView = () => {
        return (
            <div className='section-banner'>
                <Carousel autoplay={true} infinite>
                    <img src={imgBanner01} alt=""/>
                    <img src={imgBanner02} alt=""/>
                </Carousel>
            </div>
        )
    }

    generateTitleView() {
        const { couponActivity } = this.state

        return (
            <div className='section-title'>
                <div className="title word-ellipsis">
                    <i className='iconfont icon-youhuihuodong-2' style={{fontSize:20}}></i>
                    <span> {couponActivity.name?couponActivity.name:'优惠活动'}</span>
                    <span className="sub"></span>
                </div>
            </div>
        )
    }

    generateProfileView() {
        const { couponActivity } = this.state;
        if(!couponActivity || !couponActivity.couponType) {
            return
        }

        let data = []
        data.push({label: '剩余数量', value: `${couponActivity.initCount}/${couponActivity.quantity}`})
        if(couponActivity.couponType === 'GAME_MINUTES') {
            data.push({label: '游戏时间', value: CommonUtils.readableGameMinutes(couponActivity.gameMinutes)})
        } else if(couponActivity.couponType === 'PACKET_DISCOUNT') {
            data.push({label: '套餐折扣', value: couponActivity.discount + '%'})
        } else {
            data.push({label: '已领数量', value: couponActivity.toExchangeCount + couponActivity.exchangedCount})
        }
        data.push({label: '我已领取', value: `${couponActivity.grabbedCount}/${couponActivity.limitPerUser?couponActivity.limitPerUser:couponActivity.quantity}`}) 

        return <ProfileView data={data}/>
    }

    doGenerateDetailRowForDiscount = () => {
        const { couponActivity } = this.state
        if(!couponActivity || !couponActivity.id) {
            return
        }

        if(couponActivity.couponType !== 'PACKET_DISCOUNT') {
            return
        }

        let discountScope = '不限'
        if(couponActivity.bottomAmount && couponActivity.topAmount) {
            discountScope = `￥${couponActivity.bottomAmount}  ~  ￥${couponActivity.topAmount}`
        } else if(couponActivity.bottomAmount) {
            discountScope = `最低￥${couponActivity.bottomAmount}`
        } else if(couponActivity.topAmount) {
            discountScope = `最高￥${couponActivity.topAmount}`
        }

        return (
            <div className='detail-row'>
                <span className='detail-label'>适用套餐：</span>
                <span className='detail-value'>{discountScope}</span>
            </div>
        )

    }

    generateDetailView = () => {
        const { couponActivity } = this.state
        if(!couponActivity || !couponActivity.id) {
            return
        }

        return (
            <div className='section-detail'>
                {this.doGenerateDetailRowForDiscount()}
                <div className='detail-row'>
                    <span className='detail-label'>设备类型：</span>
                    <span className='detail-value'>{CommonUtils.resolveDictText(couponActivity.deviceType, this.state.deviceTypes, 'code', 'name')}</span>
                </div>
                <div className='detail-row'>
                    <span className='detail-label'>适用门店：</span>
                    <span className='detail-value'>{couponActivity.siteNames?couponActivity.siteNames.join(','):'全国门店'}</span>
                </div>
                <div className='detail-row'>
                    <span className='detail-label'>活动时间：</span>
                    <span className='detail-value'>{CommonUtils.shortenDateTime(couponActivity.startTime)}  ~  {CommonUtils.shortenDateTime(couponActivity.endTime)}</span>
                </div>
                <div className='detail-row'>
                    <span className='detail-label'>活动描述：</span>
                    <span className='detail-value'>{couponActivity.description}</span>
                </div>
            </div>
        )
    }

    generateActionView = () => {
        const { enableGrab, couponActivity } = this.state

        let grabText = '马上抢券'
        if(!couponActivity || !couponActivity.progress) {
            grabText = '加载中...'
        } else if(!couponActivity.canGrab) {
            grabText = '已领取'
        } else if(couponActivity.progress === 'PREPARING') {
            grabText = '活动未开始'
        } else if(couponActivity.progress === 'FINISHED') {
            grabText = '活动已结束'
        } else if(!enableGrab){
            grabText = '抢券中...'
        }

        return (
            <div className="section-action">
                <div className="wrapper-content">
                    <List>
                        <List.Item>
                            <Button type="primary" onClick={this.handleGrabClick} disabled={!enableGrab}>{grabText}</Button>
                        </List.Item>
                    </List>
                    <div className='action-use-coupon' onClick={this.handleUseCouponClick}>
                        <i className='iconfont icon-youxiyouxiji'></i>
                        <span> 去使用优惠券</span>
                    </div>
                </div>
            </div>
        )
    }

    generateQRCodeView = () => {
        const { brandInfo } = this.state
        if(!brandInfo || CommonUtils.isEmpty(brandInfo.wxmpQrCode)) {
            return
        }

        return (
            <div className='section-qrcode'>
                <div className='qrcode-content'>
                    <img src={brandInfo.wxmpQrCode} alt=""/>
                </div>
                <div className='qrcode-tip'>关注公众号</div>
            </div>
        )
    }

    doRenderView() {
        return (
            <div className="page-user-coupon-activity">
                {this.generateBannerView()}
                <Blank/>
                {this.generateTitleView()}
                {this.generateProfileView()}
                <Blank/>
                {this.generateDetailView()}
                {this.generateActionView()}
                {this.generateQRCodeView()}
            </div>
        )
    }

    render() {
        const {status} = this.state;

        if(status === 'loading') {
            return <LoadingPlaceholder/>;
        } else if (status === 'noauth') {
            return <TipPlaceholder firstTip={Constants.Strings.APP_NAME} secondTip={'请重新扫码'}/>;
        } else {
            return this.doRenderView()
        }
    }
}

export default createForm()(UserCouponActivity);


// WEBPACK FOOTER //
// ./src/modules/UserCouponActivity.js